import { ApiResponse } from 'apisauce';

import { GatewayResponse } from '~types/gateway';

import UtilFunctions from '~utils/functions';
import { TCreateCustomerTransferAPIParams, TCreateCustomerTransferAPIResponse, TCreateCustomerTransferDraftsAPIParams, TCreateCustomerTransferDraftsAPIResponse, TCreateCustomerTransferFinalDraftsAPIParams, TCreateCustomerTransferFinalDraftsParams, TGetCustomerTransferDetailsAPIParams, TGetCustomerTransferDetailsAPIResponse, TGetCustomerTransferListingAPIParams, TGetCustomerTransferListingAPIResponse, TGetCustomerTransferSummaryAPIParams, TGetCustomerTransferSummaryAPIResponse, TGetExportCustomerTransferListingAPIParams, TGetExportCustomerTransferListingAPIResponse } from '~types/feat/customerTransfer';
import { ICustomerTransferGateway } from './customerTransferBase';

const { API: { getHeaders } } = UtilFunctions;

export default class CustomerTransferGateway extends ICustomerTransferGateway {
    async getCustomerTransferListing(params: TGetCustomerTransferListingAPIParams): GatewayResponse<TGetCustomerTransferListingAPIResponse> {
        const { authToken, ...restOfGetCustomerTransferListingAPIParams } = params;
        const response: ApiResponse<TGetCustomerTransferListingAPIResponse> = await this.api.get('/customers-transfers', restOfGetCustomerTransferListingAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async exportCustomerTransferListing(params: TGetExportCustomerTransferListingAPIParams): GatewayResponse<TGetExportCustomerTransferListingAPIResponse> {
        const { authToken, ...restOfGetCustomerTransferListingAPIParams } = params;
        const response: ApiResponse<TGetExportCustomerTransferListingAPIResponse> = await this.api.get('/customers-transfers/export', restOfGetCustomerTransferListingAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getCustomerTransferDetails(params: TGetCustomerTransferDetailsAPIParams): GatewayResponse<TGetCustomerTransferDetailsAPIResponse> {
        const { authToken, id } = params;
        const response: ApiResponse<TGetCustomerTransferDetailsAPIResponse> = await this.api.get(`/customers-transfers/${id}`, {}, getHeaders(authToken));
        return this.process(response);
    }

    async createCustomerTransferDrafts(params: TCreateCustomerTransferDraftsAPIParams): GatewayResponse<TCreateCustomerTransferDraftsAPIResponse> {
        const { authToken } = params;
        const response: ApiResponse<TCreateCustomerTransferDraftsAPIResponse> = await this.api.post('/customers-transfers/drafts', {}, getHeaders(authToken));
        return this.process(response);
    }

    async createCustomerTransferFinalDrafts(params: TCreateCustomerTransferFinalDraftsAPIParams): GatewayResponse<TCreateCustomerTransferFinalDraftsParams> {
        const { authToken, id, ...restOfCreateCustomerTransferFinalDraftsAPIParams } = params;
        const response: ApiResponse<TCreateCustomerTransferFinalDraftsParams> = await this.api.put(`/customers-transfers/drafts/${id}`, restOfCreateCustomerTransferFinalDraftsAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getCustomerTransferDraftSummary(params: TGetCustomerTransferSummaryAPIParams): GatewayResponse<TGetCustomerTransferSummaryAPIResponse> {
        const { authToken, id } = params;
        const response: ApiResponse<TGetCustomerTransferSummaryAPIResponse> = await this.api.get(`/customers-transfers/drafts/${id}/summary`, {}, getHeaders(authToken));
        return this.process(response);
    }

    async createNewCustomerTransfer(params: TCreateCustomerTransferAPIParams): GatewayResponse<TCreateCustomerTransferAPIResponse> {
        const { authToken, ...restOfCreateCustomerTransferAPIParams } = params;
        const response: ApiResponse<TCreateCustomerTransferAPIResponse> = await this.api.post('/customers-transfers', restOfCreateCustomerTransferAPIParams, getHeaders(authToken));
        return this.process(response);
    }
}
